import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=7607e4d7&scoped=true&"
import script from "./pickup.vue?vue&type=script&lang=js&"
export * from "./pickup.vue?vue&type=script&lang=js&"
import style0 from "./pickup.vue?vue&type=style&index=0&id=7607e4d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7607e4d7",
  null
  
)

export default component.exports